import { httpClient } from '@/shared/api/httpClient';
import type { IAuthRepository } from '../../domain/repositories/IAuthRepository';
import type { AuthSession } from '../../domain/entities/AuthSession';
import type { LoginResponseDTO } from '../dto/LoginResponseDTO';
import { toAuthSession } from '../mappers/authMapper';

export class RemoteAuthRepository implements IAuthRepository {
  async login(email: string, password: string): Promise<AuthSession> {
    const { data } = await httpClient.post<LoginResponseDTO>('/v1/clock/login', {
      email,
      password,
    });
    return toAuthSession(data);
  }

  async forgotPassword(email: string): Promise<void> {
    await httpClient.post('/v1/send_email_reset', { email });
  }

  async logoutDevice(idDevice: string): Promise<void> {
    // 5s timeout — a device logging out offline must not stall on the 120s default.
    await httpClient.post(`/v1/clock/app/${idDevice}/logout`, undefined, { timeout: 5_000 });
  }
}
